import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApproveService} from "./services/approve.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ClaimDto} from "../../../../../auto-generated-server-dtos/adjuster/claim/claim-dto";
import Utils from 'src/app/helpers/utils';
import { RepairDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';
import { SetUpdateForRepairCentreService } from '../../services/set-update-for-repair-centre.service';
import { concatMap } from 'rxjs';

@Component({
  selector: 'app-approve-modal',
  templateUrl: './approve-modal.component.html',
  styleUrl: './approve-modal.component.scss'
})
export class ApproveModalComponent {
  @Input() claimDto!: ClaimDto;
  @Input() repairsDto!: RepairDto[];
  @Input() repairTotal!: number;
  @Input() manuallyEnteredDeductible!: number;
  @Input() customerRecordMatch = false;
  
  @Output() refreshClaim = new EventEmitter<void>();
  
  optionalMessage: string = "";

  isBusy: boolean = false;
  showSuccess: boolean = false;
  isError: boolean = false;

  e2Url: string = "";

  constructor(
      private approveService: ApproveService, 
      private utils: Utils,
      public activeModal: NgbActiveModal,
      private setUpdateForRepairCentreService: SetUpdateForRepairCentreService
  ) {
  }



  approveClaim() {
    this.isBusy = true;
    
    this.setUpdateForRepairCentreService.SetUpdateForRepairCentre(this.claimDto.claimId).pipe(
      concatMap(() => this.approveService.approve(this.claimDto.claimId, this.optionalMessage))
    ).subscribe({
      next: () => {
        this.isBusy = false;
        const enterpriseId = this.utils.parseAuthorizationNumber(this.claimDto.authorizationNumber!)
        this.e2Url = `https://e2.eazeetrak.com/claims/${enterpriseId}/detail`;
        this.showSuccess = true;
        this.refreshClaim.emit();
      },
      error: err => {
        this.isBusy = false;
        this.isError = true;
        this.refreshClaim.emit();
      }
    });
   
  }
  
}
